import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/obchodni-podminky" as const,
	[Locale.en]: "/terms-and-conditions" as const,
} satisfies LocalizedString;

export function getTermsOfServicePath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
